import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { WidgetProps } from '@rjsf/utils';

/**
 * Switch widget for boolean on/off fields
 */
function SwitchWidget(props: WidgetProps) {
  const { value, onChange, id, disabled, readonly, label, schema, onFocus } = props;

  const handleFocus = () => {
    onFocus?.(id, String(value || false));
  };

  return (
    <div className="flex items-center justify-between gap-3 rounded-lg border p-3">
      <div className="space-y-0.5">
        {label && (
          <Label htmlFor={id} className="text-sm font-medium text-black">
            {label}
          </Label>
        )}
        {schema.description && <p className="text-muted-foreground text-xs">{schema.description}</p>}
      </div>
      <Switch
        onFocus={handleFocus}
        id={id}
        checked={!!value}
        onCheckedChange={(checked) => onChange(checked)}
        disabled={disabled || readonly}
      />
    </div>
  );
}

export default SwitchWidget;
